import type {WidgetLinkingGroupId} from '../../../enums/widget-linking-group';
import type {Widget} from './widget';
import type {WidgetSettings} from './widget-settings';

export enum WidgetNotificationType {
    SETTINGS,
    LINKING_GROUP_ID
}

export interface WidgetNotification {
    type: WidgetNotificationType;
    widget: Widget;
}

export interface WidgetSettingsNotification extends WidgetNotification {
    type: WidgetNotificationType.SETTINGS;
    settingsUpdate: Partial<WidgetSettings>;
}

export interface WidgetLinkingGroupIdNotification extends WidgetNotification {
    type: WidgetNotificationType.LINKING_GROUP_ID;
    linkingGroupId: WidgetLinkingGroupId;
}
